import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query'

import { HttpError } from '@/api/http'

import { ACCESS_CODE_QUERY_KEYS } from './keys'
import { getAccessContext, getRedemptionStatus } from './services'
import {
  GetAccessContextPayload,
  GetAccessContextResponse,
  GetRedemptionStatusPayload,
  GetRedemptionStatusResponse,
} from './types'

export const useQueryAccessContext = (
  params: GetAccessContextPayload,
  options?: Omit<UseQueryOptions<GetAccessContextResponse, HttpError>, 'queryKey' | 'queryFn'>
) => {
  const queryKey: QueryKey = [ACCESS_CODE_QUERY_KEYS.ACCESS_CONTEXT, params]
  const queryFn = () => getAccessContext(params)

  return useQuery({
    queryKey,
    queryFn,
    ...options,
  })
}

export const useQueryRedemptionStatus = (
  params: GetRedemptionStatusPayload,
  options?: Omit<UseQueryOptions<GetRedemptionStatusResponse, HttpError>, 'queryKey' | 'queryFn'>
) => {
  const queryKey: QueryKey = [ACCESS_CODE_QUERY_KEYS.REDEMPTION_STATUS, params]
  const queryFn = () => getRedemptionStatus(params)

  return useQuery({
    queryKey,
    queryFn,
    ...options,
  })
}
